import React, {Component} from 'react';
import {connect} from 'react-redux';
import fetchMiniCart from '../../actions/fetchMiniCart';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react'

class MarketMiniCart extends Component {
  componentWillMount() {
    // this.props.fetchMiniCart();
  }
  clearCart() {
    axios.post('/api/market/clearSessCart').then(()=>{
      this.props.fetchMiniCart();
    });
  }
  render() {
    if(!this.props.market_mini_cart || !this.props.market_mini_cart.price_summ_formatted) {
      return null;
    }
    return (
      <div className="hpadd20 vpadd10 bg-pc1-op80 tac">
        <div className="bold">{this.props.t.cart}</div>
        <div className="fs20 pbottom10">
          {this.props.market_mini_cart.price_summ_formatted} <i className={`mdi mdi-currency-${this.props.market_mini_cart.currency}`} />
        </div>
        <div className="pbottom10">
          <Link to="/market/cart">{this.props.t.go_to_the_cart}</Link>
        </div>
        <a href="#" onClick={(e)=>{ e.preventDefault(); this.clearCart() }}>{this.props.t.clear_cart}</a>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    market_mini_cart:state.market_mini_cart,
    t:state.translate.evaMarket,
  }
}

// export default connect(mapStateToProps,{ fetchMiniCart })(MarketMiniCart);
export default inject("translateStore")(observer(MarketMiniCart));